<template>
  <div>
    <CRow>
      <CCol md="12">
        <CCard>
          <CCardBody>

                <InventoryItemsListReport :product_master_name="name" :models="unit_model_items"/>

          </CCardBody>
        </CCard>
      </CCol>
    </CRow>

  </div>
</template>

<script>
import axios from "axios";
import {bus} from '../../../main';

import InventoryItemsListReport from "./InventoryItemsListReport";

export default {
  name: 'Login',
  components: {

    InventoryItemsListReport,
  },
  data() {
    return {
      confirm_delete_name: "confirm" + new Date().getTime() + "_" + this.$vnode.tag,
      name: '',
      selected_product_name: '',
      unit_model_items: [],

    }
  }, mounted() {

  }, watch: {

  },
  methods: {

  }
}

</script>
